import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

import Input, { STYLE_TYPE } from 'components/Forms/Fields/TextInput';
import passwordShow from 'images/icon_visible.svg';
import passwordHide from 'images/icon_invisible.svg';

import Image from 'components/Image';
import styles from './index.module.scss';

const Password = ({ id, fieldName, placeholder, onChange, onFocus, error }) => {
  const [show, setShow] = useState(false);
  return (
    <FormControl className={styles.formCntrl}>
      <Input
        className={styles.blackText}
        id={id}
        type={show ? 'text' : 'password'}
        field={fieldName}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        error={error ? error : null}
        styleType={STYLE_TYPE.loginInput}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={() => setShow(!show)}
            >
              <Image
                className={styles.pwdIcon}
                src={show ? passwordShow : passwordHide}
              />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};

Password.propTypes = {
  id: PropTypes.string,
  fieldName: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  error: PropTypes.string,
};

export default Password;
